import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import BonusesTable from "./BonusesTable";
import ClaimsTable from "./ClaimsTable";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
    boxSizing: "border-box",
  },
  title: {
    color: theme.colors.Violet,
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    fontSize: "24px",
    marginBottom: "6px",
  },
  description: {
    color: theme.colors.DodgerBlue,
    fontFamily: theme.fontFamily.MARKPROBOOK,
    fontSize: "14px",
    marginBottom: "24px",
  },
  tabs: {
    display: "inline-flex",
    backgroundColor: theme.colors.Zumthor,
    borderRadius: "999px",
    padding: "4px",
    marginBottom: "28px",
  },
  tab: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: "8px 22px",
    borderRadius: "999px",
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    fontSize: "14px",
    color: theme.colors.Violet,
    transition: "all 0.15s ease",
    outline: "none",
  },
  tabActive: {
    backgroundColor: theme.colors.DodgerBlue,
    color: theme.colors.White,
    boxShadow: "0px 4px 12px rgba(62, 131, 250, 0.25)",
  },
}));

const TABS = [
  { key: "bonuses", label: "Bonuses" },
  { key: "claims", label: "Claims" },
];

function BonusesAdminPage() {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState("bonuses");

  return (
    <div className={classes.root}>
      <div className={classes.title}>Bonuses</div>
      <div className={classes.description}>
        Manage bonuses and review the claims employees redeem against them.
      </div>

      <div className={classes.tabs} role="tablist" aria-label="Bonuses sections">
        {TABS.map((t) => (
          <button
            key={t.key}
            role="tab"
            aria-selected={activeTab === t.key}
            className={`${classes.tab} ${
              activeTab === t.key ? classes.tabActive : ""
            }`}
            onClick={() => setActiveTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {activeTab === "bonuses" ? <BonusesTable /> : <ClaimsTable />}
    </div>
  );
}

export default BonusesAdminPage;
